module.exports = __webpack_public_path__ + "img/unicredit.ca6587f3.svg";